import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import {
  cohortLabel,
  orMissing,
} from '@backrs_ui/grow-ui/src/pages/CoachingDashboard/namedRefLabel';
import type {
  AdminCode,
  AdminCohort,
  MintedCode,
} from '@backrs_ui/grow-ui/src/redux/institutionAdmin';

export const institutionAdminStrings = appStrings.modules.coachingDashboard.institutionAdmin;

export const { cohorts: cohortStrings, codes: codeStrings } = institutionAdminStrings;

export const {
  revokeDialog: revokeStrings,
  coachesDialog: coachesDialogStrings,
  renameDialog: renameStrings,
} = appStrings.modules.rostersAdmin;

export const createdMessage = (cohort: AdminCohort): string =>
  cohort.shareCode
    ? cohortStrings.create.created(cohortLabel(cohort), cohort.shareCode)
    : cohortStrings.create.createdWithoutShareCode(cohortLabel(cohort));

/** A recycled code names what it is already active for, so the operator learns
 * why no new code appeared rather than reading the mint as a no-op. */
export const mintedMessage = ({ code, recycled }: MintedCode): string => {
  if (!recycled) return codeStrings.mint.minted(code.value);

  return code.cohort === null
    ? codeStrings.mint.recycledRosterWide(code.value)
    : codeStrings.mint.recycled(code.value);
};

export const revokedMessage = (code: AdminCode): string =>
  revokeStrings.revoked(orMissing(code.value));
